export const isReportsView = () => {
    return window.location.hash.startsWith('#/reports');
};
